import { Fragment, useEffect } from 'react';
import AOS from 'aos';
import LoadingOverlay from 'react-loading-overlay';
import { useSelector } from 'react-redux';
import MainRouter from './content/MainRouter';

import './App.less';
import 'aos/dist/aos.css';

LoadingOverlay.propTypes = undefined;

function App() {
  const { loading } = useSelector(state => state.apps);

  useEffect(() => {
    AOS.init({
      duration: 1000, // Durasi animasi (1 detik)
    });
  }, []);

  useEffect(() => {
    let scrollTimeout;
    const root = document.documentElement;

    const hasOverflow = () => (
      root.scrollHeight > root.clientHeight || root.scrollWidth > root.clientWidth
    );

    const hideScrollbar = () => {
      if (!hasOverflow()) {
        root.classList.remove('scrollbar-visible');
      }
    };

    const handleScroll = () => {
      if (!hasOverflow()) {
        root.classList.remove('scrollbar-visible');
        return;
      }
      root.classList.add('scrollbar-visible');
      clearTimeout(scrollTimeout);
      scrollTimeout = window.setTimeout(() => {
        root.classList.remove('scrollbar-visible');
      }, 600);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', hideScrollbar);

    hideScrollbar();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', hideScrollbar);
      clearTimeout(scrollTimeout);
    };
  }, []);

  return (
    <Fragment>
      <LoadingOverlay
        active={loading}
        spinner
        text="Loading"
      >
        <MainRouter />
      </LoadingOverlay>
    </Fragment>
  );
}

export default App;
